/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './conditions.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/forms';
import * as i3 from '../../../../app/multi-editor/conditions/conditions.component';
import * as i4 from '../autocomplete-input/autocomplete-input.component.ngfactory';
import * as i5 from '../../../../app/multi-editor/autocomplete-input/autocomplete-input.component';
import * as i6 from '../../../../app/multi-editor/shared/services/schema-keys-store.service';
import * as i7 from '@angular/common';
const styles_ConditionsComponent:any[] = [i0.styles];
export const RenderType_ConditionsComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_ConditionsComponent,data:{}});
function View_ConditionsComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),3,'option',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),i1.ɵdid(1,
      147456,(null as any),0,i2.NgSelectOption,[i1.ElementRef,i1.Renderer2,[2,i2.SelectControlValueAccessor]],
      {ngValue:[0,'ngValue']},(null as any)),i1.ɵdid(2,147456,(null as any),0,i2.ɵq,
      [i1.ElementRef,i1.Renderer2,[8,(null as any)]],{ngValue:[0,'ngValue']},(null as any)),
      (_l()(),i1.ɵted(3,(null as any),[' ',' ']))],(_ck,_v) => {
    const currVal_0:any = _v.context.$implicit;
    _ck(_v,1,0,currVal_0);
    const currVal_1:any = _v.context.$implicit;
    _ck(_v,2,0,currVal_1);
  },(_ck,_v) => {
    const currVal_2:any = _v.context.$implicit;
    _ck(_v,3,0,currVal_2);
  });
}
function View_ConditionsComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),5,'input',[['class',
      'form-control input-sm'],['name','value'],['placeholder','condition value'],
      ['type','text']],[[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],
      [2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],
      [2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],[[(null as any),
      'ngModelChange'],[(null as any),'input'],[(null as any),'blur'],[(null as any),
      'compositionstart'],[(null as any),'compositionend']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('input' === en)) {
      const pd_0:any = ((<any>i1.ɵnov(_v,1)._handleInput($event.target.value)) !== false);
      ad = (pd_0 && ad);
    }
    if (('blur' === en)) {
      const pd_1:any = ((<any>i1.ɵnov(_v,1).onTouched()) !== false);
      ad = (pd_1 && ad);
    }
    if (('compositionstart' === en)) {
      const pd_2:any = ((<any>i1.ɵnov(_v,1)._compositionStart()) !== false);
      ad = (pd_2 && ad);
    }
    if (('compositionend' === en)) {
      const pd_3:any = ((<any>i1.ɵnov(_v,1)._compositionEnd($event.target.value)) !== false);
      ad = (pd_3 && ad);
    }
    if (('ngModelChange' === en)) {
      const pd_4:any = ((<any>(_co.condition.value = $event)) !== false);
      ad = (pd_4 && ad);
    }
    return ad;
  },(null as any),(null as any))),i1.ɵdid(1,16384,(null as any),0,i2.DefaultValueAccessor,
      [i1.Renderer2,i1.ElementRef,[2,i2.COMPOSITION_BUFFER_MODE]],(null as any),(null as any)),
      i1.ɵprd(1024,(null as any),i2.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i2.DefaultValueAccessor]),i1.ɵdid(3,671744,(null as any),0,i2.NgModel,[[2,
          i2.ControlContainer],[8,(null as any)],[8,(null as any)],[2,i2.NG_VALUE_ACCESSOR]],
          {name:[0,'name'],model:[1,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,
          (null as any),i2.NgControl,(null as any),[i2.NgModel]),i1.ɵdid(5,16384,(null as any),
          0,i2.NgControlStatus,[i2.NgControl],(null as any),(null as any))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_7:any = 'value';
    const currVal_8:any = _co.condition.value;
    _ck(_v,3,0,currVal_7,currVal_8);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,5).ngClassUntouched;
    const currVal_1:any = i1.ɵnov(_v,5).ngClassTouched;
    const currVal_2:any = i1.ɵnov(_v,5).ngClassPristine;
    const currVal_3:any = i1.ɵnov(_v,5).ngClassDirty;
    const currVal_4:any = i1.ɵnov(_v,5).ngClassValid;
    const currVal_5:any = i1.ɵnov(_v,5).ngClassInvalid;
    const currVal_6:any = i1.ɵnov(_v,5).ngClassPending;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
  });
}
export function View_ConditionsComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),38,'form',[['class',
      'form-inline'],['novalidate','']],[[2,'ng-untouched',(null as any)],[2,'ng-touched',
      (null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],
      [2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',
          (null as any)]],[[(null as any),'submit'],[(null as any),'reset']],(_v,en,
      $event) => {
    var ad:boolean = true;
    if (('submit' === en)) {
      const pd_0:any = ((<any>i1.ɵnov(_v,2).onSubmit($event)) !== false);
      ad = (pd_0 && ad);
    }
    if (('reset' === en)) {
      const pd_1:any = ((<any>i1.ɵnov(_v,2).onReset()) !== false);
      ad = (pd_1 && ad);
    }
    return ad;
  },(null as any),(null as any))),i1.ɵdid(1,16384,(null as any),0,i2.ɵbf,([] as any[]),
      (null as any),(null as any)),i1.ɵdid(2,16384,(null as any),0,i2.NgForm,[[8,(null as any)],
      [8,(null as any)]],(null as any),(null as any)),i1.ɵprd(2048,(null as any),i2.ControlContainer,
      (null as any),[i2.NgForm]),i1.ɵdid(4,16384,(null as any),0,i2.NgControlStatusGroup,
      [i2.ControlContainer],(null as any),(null as any)),(_l()(),i1.ɵted(-1,(null as any),
      ['\n  '])),(_l()(),i1.ɵeld(6,0,(null as any),(null as any),1,'label',[['class',
      'form-group']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['Field:'])),(_l()(),i1.ɵted(-1,(null as any),
          ['\n  '])),(_l()(),i1.ɵeld(9,0,(null as any),(null as any),5,'div',[['class',
          'form-group']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵeld(11,0,(null as any),
          (null as any),2,'re-autocomplete-input',[['name','key'],['placeholder','field key'],
              ['type','text']],(null as any),[[(null as any),'valueChange']],(_v,en,
              $event) => {
            var ad:boolean = true;
            var _co:i3.ConditionsComponent = _v.component;
            if (('valueChange' === en)) {
              const pd_0:any = ((<any>(_co.condition.key = $event)) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i4.View_AutocompleteInputComponent_0,i4.RenderType_AutocompleteInputComponent)),
      i1.ɵdid(12,49152,(null as any),0,i5.AutocompleteInputComponent,[i6.SchemaKeysStoreService],
          {placeholder:[0,'placeholder']},{valueChange:'valueChange'}),(_l()(),i1.ɵted(-1,
          (null as any),['\n    '])),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),
          i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵeld(16,0,(null as any),(null as any),
          21,'div',[['class','form-group']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),
      (_l()(),i1.ɵeld(18,0,(null as any),(null as any),12,'div',[['class','btn-group dropdown']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n      '])),(_l()(),i1.ɵeld(20,0,(null as any),
          (null as any),9,'select',[['class','form-control selector input-sm'],['name',
              'matchSelector']],[[2,'ng-untouched',(null as any)],[2,'ng-touched',
              (null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],
              [2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',
                  (null as any)]],[[(null as any),'ngModelChange'],[(null as any),
              'change'],[(null as any),'blur']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i3.ConditionsComponent = _v.component;
            if (('change' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,21).onChange($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,21).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_2:any = ((<any>(_co.condition.matchType = $event)) !== false);
              ad = (pd_2 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(21,16384,(null as any),0,i2.SelectControlValueAccessor,
          [i1.Renderer2,i1.ElementRef],(null as any),(null as any)),i1.ɵprd(1024,(null as any),
          i2.NG_VALUE_ACCESSOR,(p0_0:any) => {
            return [p0_0];
          },[i2.SelectControlValueAccessor]),i1.ɵdid(23,671744,(null as any),0,i2.NgModel,
          [[2,i2.ControlContainer],[8,(null as any)],[8,(null as any)],[2,i2.NG_VALUE_ACCESSOR]],
          {name:[0,'name'],model:[1,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,
          (null as any),i2.NgControl,(null as any),[i2.NgModel]),i1.ɵdid(25,16384,
          (null as any),0,i2.NgControlStatus,[i2.NgControl],(null as any),(null as any)),
      (_l()(),i1.ɵted(-1,(null as any),['\n        '])),(_l()(),i1.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_ConditionsComponent_1)),i1.ɵdid(28,802816,
          (null as any),0,i7.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,i1.IterableDiffers],
          {ngForOf:[0,'ngForOf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),
          ['\n      '])),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵted(-1,
          (null as any),['\n    '])),(_l()(),i1.ɵeld(32,0,(null as any),(null as any),
          4,'div',[['class','form-group']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n      '])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ConditionsComponent_2)),
      i1.ɵdid(35,16384,(null as any),0,i7.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),
      (_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵted(-1,(null as any),
          ['\n']))],(_ck,_v) => {
    var _co:i3.ConditionsComponent = _v.component;
    const currVal_7:any = 'field key';
    _ck(_v,12,0,currVal_7);
    const currVal_15:any = 'matchSelector';
    const currVal_16:any = _co.condition.matchType;
    _ck(_v,23,0,currVal_15,currVal_16);
    const currVal_17:any = _co.matchTypes;
    _ck(_v,28,0,currVal_17);
    const currVal_18:boolean = !(_co.condition.matchType === 'does not exist');
    _ck(_v,35,0,currVal_18);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,4).ngClassUntouched;
    const currVal_1:any = i1.ɵnov(_v,4).ngClassTouched;
    const currVal_2:any = i1.ɵnov(_v,4).ngClassPristine;
    const currVal_3:any = i1.ɵnov(_v,4).ngClassDirty;
    const currVal_4:any = i1.ɵnov(_v,4).ngClassValid;
    const currVal_5:any = i1.ɵnov(_v,4).ngClassInvalid;
    const currVal_6:any = i1.ɵnov(_v,4).ngClassPending;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
    const currVal_8:any = i1.ɵnov(_v,25).ngClassUntouched;
    const currVal_9:any = i1.ɵnov(_v,25).ngClassTouched;
    const currVal_10:any = i1.ɵnov(_v,25).ngClassPristine;
    const currVal_11:any = i1.ɵnov(_v,25).ngClassDirty;
    const currVal_12:any = i1.ɵnov(_v,25).ngClassValid;
    const currVal_13:any = i1.ɵnov(_v,25).ngClassInvalid;
    const currVal_14:any = i1.ɵnov(_v,25).ngClassPending;
    _ck(_v,20,0,currVal_8,currVal_9,currVal_10,currVal_11,currVal_12,currVal_13,currVal_14);
  });
}
export function View_ConditionsComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'re-conditions',
      ([] as any[]),(null as any),(null as any),(null as any),View_ConditionsComponent_0,
      RenderType_ConditionsComponent)),i1.ɵdid(1,49152,(null as any),0,i3.ConditionsComponent,
      ([] as any[]),(null as any),(null as any))],(null as any),(null as any));
}
export const ConditionsComponentNgFactory:i1.ComponentFactory<i3.ConditionsComponent> = i1.ɵccf('re-conditions',
    i3.ConditionsComponent,View_ConditionsComponent_Host_0,{condition:'condition'},
    {},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// /home/travis/build/inspirehep/record-editor/src/$$_gendir/app/multi-editor/conditions/conditions.component.ngfactory.ts